<template>
  <div class="header-count">
    <div class="container">
      <div class="header-count_wrap">
        <div class="row justify-content-md-around justify-content-lg-between">
          <div class="col-auto">
            <div class="header-count-item">
              <div class="header-count-title">ТОП 15 <br>спикеров</div>
              <div class="header-count-desc">Бизнес, психология,<br> духовный мир, <br>наука</div>
            </div>
          </div>
          <div class="col-auto">
            <div class="header-count-item">
              <div class="header-count-title">700 м2 + <br>площадь</div>
              <div class="header-count-desc">Уникального <br>пространства <br>событий «Матрешка»</div>
            </div>
          </div>
          <div class="col-auto">
            <div class="header-count-item">
              <div class="header-count-title">500+ <br>участников</div>
              <div class="header-count-desc">
                Эксперты well being,<br> предприниматели,<br> специальные гости –<br> «Селебрити»
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="header-count-item">
              <div class="header-count-title">Anti-conference <br>формат</div>
              <div class="header-count-desc">
                5 зон с активностями.<br> 10+ воркшопов<br> с уникальным форматом<br> контента
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="header-count-item">
              <div class="header-count-title">Современные<br> иммерсивные</div>
              <div class="header-count-desc">
                Экспозиции<br> на цифровых<br> модульных экранах
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainCount"
}
</script>

<style lang="scss" scoped>
.header-count {
  padding-top: 0;
  @include _768 {
    padding-top: 120px;
  }
}
.header-count_wrap {
  background: var(--bg-grad, linear-gradient(90deg, #2C11B4 0%, #B50E90 135.16%));
  margin-left: -1rem;
  margin-right: -1rem;
  padding: 40px 1rem;
  @include _576 {
    border-radius: 16px;
    margin: 0;
  }
  @include _992 {
    padding: 30px 40px;
  }
}

.header-count-item {
  color: white;
  margin-bottom: 32px;
  @include _992 {
    margin-bottom: 0;
  }

  .header-count-title {
    font-family: 'Play', sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 128%; /* 35.84px */
    margin-bottom: 18px;
    @include _768 {
      font-size: 22px;
      line-height: 116%;
    }
  }

  .header-count-desc {
    color: var(--gray, #C7C7D1);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 20.48px */
    br {
      display: none;
    }

    @include _768 {
      font-size: 18px;
      line-height: 136%;
      br {
        display: inherit;
      }
    }
  }
}
</style>